"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";

interface SessionProviderProps {
  children: React.ReactNode;
}

export default function SessionProvider({ children }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      refetchInterval={30 * 60} // Refetch session every 30 minutes (back to original)
      refetchOnWindowFocus={false} // Disable refetch on window focus to prevent spam
      refetchWhenOffline={false} // Don't refetch when offline to prevent issues
    >
      {children}
    </NextAuthSessionProvider>
  );
}
